// extracted by mini-css-extract-plugin
export default {"wrapper":"navigation-card-list-block-module--wrapper--efe0b","list":"navigation-card-list-block-module--list--e5c52","item":"navigation-card-list-block-module--item--58a1b"};